export const isIE = function () {
  const ua = navigator.userAgent.toLocaleLowerCase();
  if (ua.match(/msie/) !== null || ua.match(/trident/) !== null) {
    return true;
  }
  return false;
};

/**
 * 为地版本不支持CSS变量的IE浏览器添加样式变量
 */
export const addCssStyle = function (color: string = '#4A70FF') {
  // 将颜色变量注入到全局，以使全局组件的颜色也能根据主题色变更。
  let css = `html, body{ --bg-color: ${color} }`;
  if (isIE()) {
    css = `.bg-primay{
      background: ${color}!important;
    }
    .txt-primay{
      color: ${color}!important;
    }
    .icon-primay{
      color: ${color}!important;
    }
    a{
      text-decoration: none;
      color: ${color};
    }`;
  }

  const cssStyle = document.createElement('style');
  cssStyle.type = 'text/css';
  cssStyle.innerHTML = css;
  document.head.appendChild(cssStyle);
};
